<h1 mat-dialog-title>
    {{ data.title }}
</h1>
<div class="spinner-wrapper">
    <mat-spinner [diameter]="180"></mat-spinner>
</div>